const gamesDb = {
  RPG: [
    {
      title: "Horizon Zero Dawn",
      description: "5/5 Post apocalyptic mecha adventure"
    },
    {
      title: "Rise of Tomb Raider",
      description: "4/5 Gods are as real as they get"
    },
    {
      title: "Prince of Persia",
      description: "4/5 Just for the nostalgia"
    }
  ],
  FPS: [
    {
      title: "Apex Legend",
      description: "4/5 Who does not play it?"
    },
    {
      title: "COD",
      description: "4/5 Roger that"
    },
    {
      title: "BGMI",
      description: "4/5 Every Indian plays this"
    }
  ],
  "puzzle-y": [
    {
      title: "Immortals Fenyx Rsing",
      description: "5/5 Where is Medusa?"
    },
    {
      title: "Assasins Creed Valhalla",
      description: "5/5 Non scalable walls are a huge pain"
    },
    {
      title: "Flow free",
      description: "5/5 Extremely addictive"
    }
  ]
};

export default gamesDb;
